import { BookingsCard } from "../../provider-bookings/BookingsCard";
import { useProviderWorkspace } from "../ProviderWorkspaceContext";
import { useProviderWorkspaceForm } from "../ProviderWorkspaceFormContext";

export function ScheduleSection() {
  const {
    activeSessionsByBookingId,
    startSessionFromBooking,
    selectedUnitId,
    selectedVenue,
    startingBookingId,
  } = useProviderWorkspace();
  const { createBookingRequestToken, operationsVersion, pendingReviewToken } = useProviderWorkspaceForm();

  return (
    <div className="grid gap-4">
      <BookingsCard
        activeSessionsByBookingId={activeSessionsByBookingId}
        createRequestToken={createBookingRequestToken}
        onStartSessionFromBooking={startSessionFromBooking}
        pendingReviewToken={pendingReviewToken}
        preferredUnitId={selectedUnitId}
        refreshToken={operationsVersion}
        selectedVenue={selectedVenue}
        startingSessionBookingId={startingBookingId}
      />
    </div>
  );
}
